export default __webpack_public_path__ + "static/20210505_KMW_by_Kruszewski_500-c3fc01ea41226181b863bcb0436618ee.jpg";